module.exports = __webpack_public_path__ + "img/phone-mini.65556712.svg";